(function () {
  var root = document.querySelector('[data-cdi-inst]');
  if (!root || root.dataset.cdiInit) return;
  root.dataset.cdiInit = '1';

  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-cdi-inst-row]'));
  if (!rows.length || typeof Intl === 'undefined') return;

  var t = {};
  var src = document.querySelector('[data-cdi-inst-i18n]');
  try {
    t = JSON.parse(src ? src.textContent : '{}');
  } catch (e) {
    return;
  }

  var DAY_INDEX = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };

  function toMin(s) {
    var p = String(s).split(':');
    return parseInt(p[0], 10) * 60 + parseInt(p[1], 10);
  }

  function parseDay(v) {
    if (!v || v === 'closed') return null;
    var p = v.split('-');
    if (p.length !== 2) return null;
    var a = toMin(p[0]);
    var b = toMin(p[1]);
    if (isNaN(a) || isNaN(b) || b <= a) return null;
    return [a, b];
  }

  function fmt(m) {
    var h = Math.floor(m / 60);
    var mm = m % 60;
    var h12 = h % 12 || 12;
    return h12 + ':' + (mm < 10 ? '0' : '') + mm + ' ' + (h >= 12 ? 'pm' : 'am');
  }

  function nowIn(tz) {
    var parts = new Intl.DateTimeFormat('en-AU', {
      timeZone: tz,
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) {
      o[p.type] = p.value;
    });
    return { day: DAY_INDEX[o.weekday], min: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10) };
  }

  function fill(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) {
      return map[k] != null ? map[k] : m;
    });
  }

  function setStatus(el, strong, rest) {
    el.textContent = '';
    var b = document.createElement('strong');
    b.textContent = strong;
    el.appendChild(b);
    if (rest) el.appendChild(document.createTextNode(' · ' + rest));
  }

  function update(row) {
    var status = row.querySelector('[data-cdi-inst-status]');
    var days = (row.dataset.hours || '').split('|').map(parseDay);
    var now;
    try {
      now = nowIn(row.dataset.tz || 'Australia/Sydney');
    } catch (e) {
      return;
    }
    if (now.day == null || isNaN(now.min)) return;

    var today = days[now.day];
    if (today && now.min >= today[0] && now.min < today[1]) {
      var left = today[1] - now.min;
      if (left <= 30) setStatus(status, fill(t.closesIn, { min: left }), '');
      else setStatus(status, t.open, fill(t.closesToday, { time: fmt(today[1]) }));
    } else {
      var rest = '';
      for (var k = 0; k < 8; k++) {
        var idx = (now.day + k) % 7;
        var r = days[idx];
        if (!r || (k === 0 && now.min >= r[0])) continue;
        if (k === 0) rest = fill(t.opensToday, { time: fmt(r[0]) });
        else if (k === 1) rest = fill(t.opensTomorrow, { time: fmt(r[0]) });
        else rest = fill(t.opensDay, { day: (t.days || [])[idx] || '', time: fmt(r[0]) });
        break;
      }
      setStatus(status, t.closed, rest);
    }

    Array.prototype.forEach.call(row.querySelectorAll('[data-days]'), function (line) {
      var isToday = line.dataset.days.split(',').indexOf(String(now.day)) !== -1;
      line.classList.toggle('is-today', isToday);
      var tag = line.querySelector('[data-cdi-inst-today]');
      if (tag) tag.textContent = isToday ? ' · ' + t.today : '';
    });
  }

  function run() {
    rows.forEach(update);
  }

  run();
  setInterval(run, 60000);
})();
